(function(){
    'use strict';
    angular.module('Filters').filter('bbaCapitalize', bbaCapitalize);

    bbaCapitalize.$inject = [];

    function bbaCapitalize(){
        return function(text){
            if(text) {
                return `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`;
            }
        }
    }
})()



// WEBPACK FOOTER //
// ./js/filters/bbaCapitalize.js